<template>
  <div style="width: 100vw;height: 100vh;">
    <div class="flexColumn functionBar">
      <div class="decorativeStripes"></div>
      <div style="height: 86%;width: 86%;">
        <van-swipe ref="functionSwipe" style="height: 100%;width: 100%" :touchable="true" :show-indicators="false">
          <van-swipe-item>

            <div v-if="sys_power_id === '5'" class="flexColumn functionBox">
              <div class="functionBoxIcon" @click="NextPerson">
                <van-icon class="iconSize" name="user-o" size="3.5rem" color="#16253E" />
                <span class="flexColumn"
                  style="justify-content: center;color: #16253E;font-size: 25px;font-weight: 700">个人工作</span>
              </div>
              <div class="functionBoxIcon" @click="NextTeam">
                <van-icon class="iconSize" name="friends-o" size="3.5rem" color="#16253E" />
                <span class="flexColumn"
                  style="justify-content: center;color: #16253E;font-size: 25px;font-weight: 700">团队工作</span>
              </div>
            </div>

            <div class="flexColumn functionBox">
              <div class="functionBoxIcon" @click="NextPerson">
                <van-icon class="iconSize" name="user-o" size="3.5rem" color="#16253E" />
                <span class="flexColumn"
                  style="justify-content: center;color: #16253E;font-size: 25px;font-weight: 700">个人审核</span>
              </div>
              <div class="functionBoxIcon" @click="NextTeam">
                <van-icon class="iconSize" name="friends-o" size="3.5rem" color="#16253E" />
                <span class="flexColumn"
                  style="justify-content: center;color: #16253E;font-size: 25px;font-weight: 700">团队审核</span>
              </div>
            </div>


            <div v-if="sys_power_id === '4'">
              <div class="functionBoxIcon" @click="DirectorNext">
                <van-icon class="iconSize" name="user-o" size="3.5rem" color="#16253E" />
                <span class="flexColumn"
                  style="justify-content: center;color: #16253E;font-size: 25px;font-weight: 700">奖惩工作</span>
              </div>
            </div>
          </van-swipe-item>
          <van-swipe-item>
            <div v-if="!firstClick">
            </div>
            <div v-if="sys_power_id === '5' && firstClick">
              <van-grid style="overflow: hidden;overflow-y: scroll;height: 400px;" v-if="EnterPerson" square
                :gutter="10" :column-num="2" clickable>
                <van-grid-item key="person_newCopy" icon="add-o" text="个人上报" to="/person_newCopy"></van-grid-item>
                <van-grid-item key="person_toBeReviewedCopy" icon="underway-o" text="待审核"
                  to="/person_toBeReviewedCopy"></van-grid-item>
                <van-grid-item key="person_rejectionCopy" icon="close" text="驳回件"
                  to="/person_rejectionCopy"></van-grid-item>
                <van-grid-item key="person_reviewedCopy" icon="passed" text="已审核"
                  to="/person_reviewedCopy"></van-grid-item>
              </van-grid>
              <van-grid style="overflow: hidden;overflow-y: scroll;height: 400px;" v-if="EnterTeam" square :gutter="10"
                :column-num="2" clickable>
                <van-grid-item key="team_newCopy" icon="plus" text="团队上报" to="/team_newCopy"></van-grid-item>
                <van-grid-item key="toBeSubmittedCopy" icon="passed" text="待提交" to="/toBeSubmittedCopy"></van-grid-item>
                <van-grid-item key="toBeConfirmCopy" icon="warning-o" text="待确认" to="/toBeConfirmCopy"></van-grid-item>
                <van-grid-item key="teamToBeReviewedCopy" icon="clock-o" text="待审核"
                  to="/teamToBeReviewedCopy"></van-grid-item>
                <van-grid-item key="rejectionCopy" icon="close" text="驳回件" to="/rejectionCopy"></van-grid-item>
                <van-grid-item key="reviewedCopy" icon="passed" text="已审核" to="/reviewedCopy"></van-grid-item>
              </van-grid>
            </div>
            <div v-if="firstClick">
              <van-grid style="overflow: hidden;overflow-y: scroll;height: 400px;" v-if="EnterPerson" square
                :gutter="10" :column-num="2" clickable>
                <van-grid-item key="individualPendingReviewCopy" icon="underway-o" text="个人待审"
                  to="/individualPendingReviewCopy"></van-grid-item>
                <van-grid-item key="personalReviewedCopy" icon="passed" text="个人已审"
                  to="/personalReviewedCopy"></van-grid-item>
                <van-grid-item key="personalRejectionCopy" icon="close" text="个人驳回"
                  to="/personalRejectionCopy"></van-grid-item>
                <van-grid-item key="auditHistoryCopy" icon="passed" text="审核历史" to="/auditHistoryCopy"></van-grid-item>
              </van-grid>
              <van-grid style="overflow: hidden;overflow-y: scroll;height: 400px;" v-if="EnterTeam" square :gutter="10"
                :column-num="2" clickable>
                <van-grid-item key="teamToBeReviewedCopy" icon="clock-o" text="团队待审"
                  to="/teamToBeReviewedCopy"></van-grid-item>
                <van-grid-item key="teamReviewedCopy" icon="passed" text="团队已审" to="/teamReviewedCopy"></van-grid-item>
                <van-grid-item key="teamRejectionCopy" icon="close" text="团队驳回" to="/teamRejectionCopy"></van-grid-item>
                <van-grid-item key="teamAuditHistoryCopy" icon="passed" text="审核历史"
                  to="/teamAuditHistoryCopy"></van-grid-item>
              </van-grid>
            </div>
            <div v-if="sys_power_id === '4' && firstClick">
              <van-grid square :gutter="10" :column-num="2" clickable>
                <van-grid-item key="director_award" icon="award-o" text="奖惩"
                  to="/staffRewardAndPunishments"></van-grid-item>
              </van-grid>
            </div>
          </van-swipe-item>
        </van-swipe>
      </div>
    </div>

    <div class="BottomBar" @click="EnterFunction">
      <div class="iconBox" v-if="escalationMenuId === '5'">
        <van-icon class="iconSize" name="wap-home-o" size="2rem" color="#16253E" />
        <!-- <span style="color: #16253E">职能</span> -->
        <span style="color: #16253E">上报</span>
      </div>

      <div class="iconBox" @click="EnterAudit" v-if="auditMenuId === '3'">
        <van-icon class="iconSize" name="todo-list" size="2rem" />
        <span>审核</span>
      </div>

      <div class="iconBox" @click="EnterReward" v-if="rewardMenuId === '4'">
        <van-icon class="iconSize" name="send-gift-o" size="2rem" />
        <span>奖惩</span>
      </div>

      <div class="iconBox" @click="EnterMyInfo">
        <van-icon class="iconSize" name="manager-o" size="2rem" />
        <span>我的</span>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { Grid, GridItem, Icon, Swipe, SwipeItem } from 'vant';

Vue.use(Grid);
Vue.use(GridItem);
Vue.use(Icon);
Vue.use(Swipe);
Vue.use(SwipeItem);

export default {
  name: "epas",
  data () {
    return {
      EnterPerson: false,
      EnterTeam: false,
      EnterQuestionnaire: false,
      sys_power_id: '',
      escalationMenuId: '',//上报id
      auditMenuId: '',//审核id
      rewardMenuId: '',//奖惩id
      firstClick: false
    }
  },

  created () {
    const userMenu = JSON.parse(window.sessionStorage.getItem("userMenu"));
    userMenu.forEach(element => {
      if (element.sys_power_id === '5') this.escalationMenuId = element.sys_power_id; this.sys_power_id = element.sys_power_id;
      if (element.sys_power_id === '4') this.rewardMenuId = element.sys_power_id; this.sys_power_id = element.sys_power_id;
      if (element.sys_power_id === '3') this.auditMenuId = element.sys_power_id; this.sys_power_id = element.sys_power_id;
    });
  },

  methods: {

    // 奖惩
    EnterReward () {
      this.$router.replace({ path: "/reward" });
    },

    // 审核
    EnterAudit () {
      this.$router.replace({ path: "/audit" });
    },

    // 上报
    EnterFunction () {
      this.$router.replace({ path: "/report" });
    },

    // 我的
    EnterMyInfo () {
      this.$router.replace({ path: "/my" });
    },

    NextPerson () {
      this.EnterTeam = false
      this.EnterPerson = true
      this.firstClick = true
      this.$refs.functionSwipe.next()
    },

    NextTeam () {
      this.EnterPerson = false
      this.EnterTeam = true
      this.firstClick = true
      this.$refs.functionSwipe.next()
    },

    DirectorNext () {
      this.firstClick = true
      this.$refs.functionSwipe.next()
    }
  },
}
</script>

<style scoped>
.flexRow {
  display: flex;
  flex-direction: row;
}

.flexColumn {
  display: flex;
  flex-direction: column;
}

.functionBar {
  position: fixed;
  top: 25%;
  left: 0;
  height: calc(75% - 60px);
  width: 100vw;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  align-items: center;
  box-shadow: 0 0 16px 2px #ececec;
}

.decorativeStripes {
  /*background-color: #16253E;*/
  width: 18%;
  height: 10px;
  margin: 15px 0;
  border-radius: 10px;
}

.functionBox {
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
}

.functionBoxIcon {
  display: flex;
  flex-direction: row;
  width: 90%;
  height: 40%;
  border-radius: 10px;
  margin-bottom: 10%;
  align-items: center;
  box-shadow: 0 0 16px 2px #ececec;
}

.BottomBar {
  position: fixed;
  top: calc(100% - 60px);
  left: 0;
  display: flex;
  width: 100vw;
  height: 60px;
  box-shadow: 0 0 16px 2px #ececec;
}

.iconBox {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.iconSize {
  width: 50%;
  margin-bottom: 5px;
}
</style>
